import React from "react";
import { getInventorySignClassName } from "../inventorySignStyles";

const InventoryChargeSign = ({ isAdd }) => (
  <span className={getInventorySignClassName(!!isAdd)}>{isAdd ? "+" : "-"}</span>
);

export default InventoryChargeSign;
